import { Grid } from "@mui/material";
import Table from "./home/table";
import React from "react";

const Transactions = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Table />
      </Grid>
    </Grid>
  );
};

export default Transactions;
